import Home from "../views/Home.vue";
import Welcome from "../views/Welcome.vue";
import Course from "../views/Course/index.vue";
import Lecture from "../views/Lecture/index.vue";
import Video from "../views/Video/index.vue";
import Exams from "../views/Exams/index.vue";
import Exam from "../views/Exam/index.vue";
import AttemptsCorrection from "../views/AttemptsCorrection/index.vue";
import Questions from "../views/Questions/index.vue";
import NewQuestion from "../views/NewQuestion/index.vue"
import EditQuestion from "../views/EditQuestion/index.vue"
import ExamSessions from "../views/ExamSessions/index.vue";
import LecturesPurchases from "../views/Purchases/index-lectures.vue";
import CoursesPurchases from "../views/Purchases/index-courses.vue";
import ExportFiles from "../views/ExportFiles/index.vue";

import Support from "../views/Support.vue";

const routes = [
    {
        path: '/',
        name: 'welcome',
        component: Welcome,
        meta :{
            requiresAuth: false,
            requiresGuest: true,
            footer: {
                show: true,
                notFixed: true,
            },
            whiteBackground: true,
        }
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        meta :{
            title: 'الصفحة الرئيسية',
            requiresAuth: true
        }
    },
    {
        path: '/courses/:id',
        name: 'course',
        component: Course,
        meta :{
            title: 'صفحة الدورة',
        }
    },
    {
        path: '/lectures/:id',
        name: 'lecture',
        component: Lecture,
        meta :{
            title: 'صفحة المحاضرة',
        }
    },
    {
        path: '/videos/:id',
        name: 'video',
        component: Video,
        meta :{
            title: 'صفحة الفيديو',
        }
    },
    {
        path: '/exams',
        name: 'exams',
        component: Exams,
        meta :{
            title: 'الامتحانات',
        }
    },
    {
        path: '/exams/:id',
        name: 'exam',
        component: Exam,
        meta :{
            title: 'صفحة الامتحان',
        }
    },
    {
        path: '/exams/:id/attempts/correction',
        name: 'attempts-correction',
        component: AttemptsCorrection,
        meta :{
            title: 'التصحيح اليدوي',
        }
    },
    {
        path: '/exams/sessions/:id',
        name: 'exam-sessions',
        component: ExamSessions,
        meta :{
            title: 'جلسات الامتحان',
        }
    },
    {
        path: '/questions',
        name: 'questions',
        component: Questions,
        meta :{
            title: 'بنك اﻷسئلة',
        }
    },
    {
        path: '/questions/create',
        name: 'new-question',
        component: NewQuestion,
        meta :{
            title: 'سؤال جديد',
        }
    },
    {
        path: '/questions/:id/edit',
        name: 'edit-question',
        component: EditQuestion,
        meta :{
            title: 'تعديل السؤال',
        }
    },
    {
        path: '/purchases/lectures',
        name: 'lectures-purchases',
        component: LecturesPurchases,
        meta :{
            title: 'عمليات شراء المحاضرات',
        }
    },
    {
        path: '/purchases/courses',
        name: 'courses-purchases',
        component: CoursesPurchases,
        meta :{
            title: 'عمليات شراء الدورات',
        }
    },
    {
        path: '/export-files',
        name: 'export-files',
        component: ExportFiles,
        meta :{
            title: 'الملفات المستخرجة',
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import("../views/Login.vue"),
        meta :{
            title: 'تسجيل الدخول',
            requiresAuth: false,
            requiresGuest: true,
        }
    },
    /* {
        path: '/register',
        name: 'register',
        component: () => import("../views/Register.vue"),
        meta :{
            title: 'إنشاء حساب جديد',
            requiresAuth: false,
            requiresGuest: true,
        }
    }, */
    {
    path: '/confirm',
    name: 'confirm',
    component: () => import( '../views/Confirm.vue'),
    meta :{
        title: 'تأكيد البريد الإلكتروني',
        requiresAuth: true,
    }
    },
    {
        path: "/help",
        name: "help",
        component: Support,
        meta: {
            title: 'المساعدة',
            footer: {
                show: true,
                notFixed: true,
            },
        }
    },
    {
        path: '*',
        name: 'not-found',
        meta: {
            title: 'الصفحة غير موجودة',
            // footer: {
            //     show: true,
            // },
            backIcon: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/NotFound.vue')
    }
  ];


  export default routes;